const BLANK_CHARS = /[\s\u200B\uFEFF\u00A0]/g

export function normalize(value: unknown): string {
    if (value === null || value === undefined) return ''
    return String(value).trim()
}

export function normalizeSymbol(value: unknown): string {
    return String(value ?? '').replace(BLANK_CHARS, '')
}

export function toNumber(value: unknown): number | null {
    if (value === null || value === undefined || value === '') return null
    const parsed = Number(value)
    return Number.isNaN(parsed) ? null : parsed
}
